import { Body } from '@assembly-js/design-system';
import { t } from 'i18next';
import React from 'react';

import { TOS_LINK } from 'src/constants/externalUrls';

/** The cancel-anytime + terms footer shared by the plan-change modals. */
export const PlanChangeTermsFooter: React.FC = () => (
  <div className="flex flex-col gap-1.5">
    <Body size="sm" className="text-gray-small">
      {t(($) => $.page_studio_plans.plan_change.cancel_anytime)}
    </Body>
    <Body size="sm" className="text-gray-small">
      {t(($) => $.page_studio_plans.plan_change.terms_prefix)}{' '}
      <a
        href={TOS_LINK}
        target="_blank"
        rel="noreferrer"
        className="text-gray-small underline"
      >
        {t(($) => $.page_studio_plans.plan_change.terms_link)}
      </a>
    </Body>
  </div>
);
